/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WebsitImageConfigInfoRespVo } from './WebsitImageConfigInfoRespVo';
import {
    WebsitImageConfigInfoRespVoFromJSON,
    WebsitImageConfigInfoRespVoFromJSONTyped,
    WebsitImageConfigInfoRespVoToJSON,
    WebsitImageConfigInfoRespVoToJSONTyped,
} from './WebsitImageConfigInfoRespVo';

/**
 * 
 * @export
 * @interface PageDataWebsitImageConfigInfoRespVo
 */
export interface PageDataWebsitImageConfigInfoRespVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataWebsitImageConfigInfoRespVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataWebsitImageConfigInfoRespVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataWebsitImageConfigInfoRespVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<WebsitImageConfigInfoRespVo>}
     * @memberof PageDataWebsitImageConfigInfoRespVo
     */
    records?: Array<WebsitImageConfigInfoRespVo>;
}

/**
 * Check if a given object implements the PageDataWebsitImageConfigInfoRespVo interface.
 */
export function instanceOfPageDataWebsitImageConfigInfoRespVo(value: object): value is PageDataWebsitImageConfigInfoRespVo {
    return true;
}

export function PageDataWebsitImageConfigInfoRespVoFromJSON(json: any): PageDataWebsitImageConfigInfoRespVo {
    return PageDataWebsitImageConfigInfoRespVoFromJSONTyped(json, false);
}

export function PageDataWebsitImageConfigInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataWebsitImageConfigInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(WebsitImageConfigInfoRespVoFromJSON)),
    };
}

export function PageDataWebsitImageConfigInfoRespVoToJSON(json: any): PageDataWebsitImageConfigInfoRespVo {
    return PageDataWebsitImageConfigInfoRespVoToJSONTyped(json, false);
}

export function PageDataWebsitImageConfigInfoRespVoToJSONTyped(value?: PageDataWebsitImageConfigInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(WebsitImageConfigInfoRespVoToJSON)),
    };
}

